var React = require('react');

function CollapseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 8H1V6h12z"}));
}

CollapseInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = CollapseInline;

CollapseInline.default = CollapseInline;
